import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const LeaderboardSkeleton = () => {
    return (
        <div className="max-w-3xl mx-auto space-y-3">
            {Array.from({ length: 10 }).map((_, index) => (
                <div key={index} className="bg-gray-800/50 border border-gray-700 rounded-lg p-4 flex items-center justify-between">
                    <div className="flex items-center gap-4">
                        <SkeletonLoader className="w-8 h-8 rounded-full" />
                        <div>
                            <SkeletonLoader className="h-5 w-32 mb-2" />
                            <SkeletonLoader className="h-4 w-48" />
                        </div>
                    </div>
                    <div className="text-right">
                        <SkeletonLoader className="h-6 w-20 mb-2" />
                        <SkeletonLoader className="h-3 w-12" />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default LeaderboardSkeleton;
